/**
 * nordura-faq.js
 * Category filter + single-open accordion for sections/faq-accordion.liquid.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('.n-faq').forEach(function (section) {
      if (section.dataset.nFaqBound) return;
      section.dataset.nFaqBound = 'true';

      var tabs = section.querySelectorAll('[data-n-faq-category]');
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-n-faq-item]'));
      var currentCategory = tabs.length ? tabs[0].dataset.nFaqCategory : null;

      function applyFilter() {
        items.forEach(function (item) {
          item.hidden = currentCategory ? item.dataset.category !== currentCategory : false;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          currentCategory = tab.dataset.nFaqCategory;
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          applyFilter();
        });
      });

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-n-faq-toggle]');
        var answer = item.querySelector('[data-n-faq-answer]');
        var icon = item.querySelector('[data-n-faq-icon]');
        if (!toggle || !answer) return;
        toggle.addEventListener('click', function () {
          var isOpen = !answer.hidden;
          // Close every other open answer within this section (single-open accordion).
          section.querySelectorAll('[data-n-faq-answer]').forEach(function (a) { a.hidden = true; });
          section.querySelectorAll('[data-n-faq-icon]').forEach(function (i) { i.textContent = '+'; });
          if (!isOpen) {
            answer.hidden = false;
            if (icon) icon.textContent = '−';
          }
        });
      });

      applyFilter();
    });
  }
})();
